import { compact } from 'lodash';
import { ModelConstants, azureStorageAuthTypes } from 'shell-models-lib';

export const isolationLevelConst = {
    ReadCommitted: 'ReadCommitted',
    ReadUncommitted: 'ReadUncommitted',
    RepeatableRead: 'RepeatableRead',
    Serializable: 'Serializable',
    Snapshot: 'Snapshot'
};

export type IsolationLevelType = 'ReadCommitted' | 'ReadUncommitted' | 'RepeatableRead' | 'Serializable' | 'Snapshot';

export const dataWarehouseAllowedSourceAuthTypes = compact([
    azureStorageAuthTypes.SasUriAuthentication,
    azureStorageAuthTypes.Anonymous,
    azureStorageAuthTypes.AccountKeyAuthentication,
    __IS_FABRIC_DPE__ ? azureStorageAuthTypes.UserAuth : undefined
]);

/**
 * Engine Edition is a SQL Server Property that returns the database engine edition of the SQL Server instance
 * @see https://learn.microsoft.com/en-us/sql/t-sql/functions/serverproperty-transact-sql
 * 1 = Personal or Desktop Engine (Not available in SQL Server 2005 (9.x) and later versions.)
 * 2 = Standard (For Standard, Web, and Business Intelligence.)
 * 3 = Enterprise (For Evaluation, Developer, and Enterprise editions.)
 * 4 = Express (For Express, Express with Tools, and Express with Advanced Services)
 * 5 = SQL Database
 * 6 = Azure Synapse Analytics
 * 8 = Azure SQL Managed Instance
 * 9 = Azure SQL Edge (For all editions of Azure SQL Edge)
 * 11 = Azure Synapse serverless SQL pool
 */
export const SQL_ENGINE_EDITION = {
    STANDARD: 2,
    ENTERPRISE: 3,
    EXPRESS: 4,
    SQL_DATABASE: 5,
    AZURE_SYNAPSE_ANALYTICS: 6,
    AZURE_SQL_MANAGED_INSTANCE: 8
};

export const SQL_ENGINE_EDITION_TO_LS_TYPE_MAP: Record<number, string> = {
    [SQL_ENGINE_EDITION.STANDARD]: ModelConstants.sqlServerLinkedService,
    [SQL_ENGINE_EDITION.ENTERPRISE]: ModelConstants.sqlServerLinkedService,
    [SQL_ENGINE_EDITION.EXPRESS]: ModelConstants.sqlServerLinkedService,
    [SQL_ENGINE_EDITION.SQL_DATABASE]: ModelConstants.azureSqlDatabase,
    [SQL_ENGINE_EDITION.AZURE_SYNAPSE_ANALYTICS]: ModelConstants.synapseLinkedService,
    [SQL_ENGINE_EDITION.AZURE_SQL_MANAGED_INSTANCE]: ModelConstants.azureSqlMiDatabase
};

export type EncryptType = 'true'|'false'|'strict';

/***
 * additional properties
 */
export type AdditionalPropertiesKeyType =
    | 'applicationIntent'
    | 'connectTimeout'
    | 'connectRetryCount'
    | 'connectRetryInterval'
    | 'loadBalanceTimeout'
    | 'commandTimeout'
    | 'integratedSecurity'
    | 'failoverPartner'
    | 'maxPoolSize'
    | 'minPoolSize'
    | 'multipleActiveResultSets'
    | 'multiSubnetFailover'
    | 'packetSize'
    | 'pooling';

export const additionalPropertiesKeyList = [
    'applicationIntent',
    'connectTimeout',
    'connectRetryCount',
    'connectRetryInterval',
    'loadBalanceTimeout',
    'commandTimeout',
    'integratedSecurity',
    'failoverPartner',
    'maxPoolSize',
    'minPoolSize',
    'multipleActiveResultSets',
    'multiSubnetFailover',
    'packetSize',
    'pooling'
];

export const additionalPropertiesAdapts = {
    applicationIntent: '*',
    connectTimeout: '*',
    connectRetryCount: '*',
    connectRetryInterval: '*',
    loadBalanceTimeout: '*',
    commandTimeout: '*',
    integratedSecurity: '*',
    failoverPartner: '*',
    maxPoolSize: '*',
    minPoolSize: '*',
    multipleActiveResultSets: '*',
    multiSubnetFailover: '*',
    packetSize: '*',
    pooling: '*'
};
